<template>
  <div class="tour" :class="{'map-open': isMapOpen}" v-if="currentTour" role="presentation">
    <header-mobile>
      <h3>{{ $tr(currentTour.name) }}</h3>
    </header-mobile>
    <main class="content" aria-label="Main content">
      <GeoLocationNotification />
      <article
        v-if="currentTour.information"
        v-html="$tr(currentTour.information)"
        class="description"
        aria-label="Description"
      />
      <poi-map :poiList="poiList"
               :position="position"
               :directions="true"
               :visible="isMapOpen"
               @directions-error="onDirectionsError"
               :routingType="currentTour.routingType"
               ref="map" />
      <div class="btn-container">
        <button class="btn btn-secondary main-color btn-main"
             :disabled="!mapAllowed"
             @click="isMapOpen = !isMapOpen"
             style="margin-right:5px;">
             <i aria-hidden="true" class="material-icons">map</i>{{ $t("curatedTour.viewRoute") }}
        </button>
        <button class="btn btn-primary main-background secondary-text pulse"
             :disabled="poiList.length === 0 || hasError"
             @click="startTour" style="margin-left:5px;">
             <i aria-hidden="true" class="material-icons">navigation</i>{{ $t("curatedTour.startTour") }}
        </button>
      </div>
      <p class="error-message" v-if="hasError">Unfortunately this tour can't be routed by Google. Please, try another one</p>
      <poi-list :poiList="poiList" />
    </main>
  </div>
</template>

<script>
import HeaderMobile from '@/components/HeaderMobile'
import PoiList from '@/components/PoiList'
import PoiMap from '@/components/PoiMap'
import GeoLocationNotification from '@/components/GeoLocationNotification'

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'Tour',
  props: {
    id: {
      required: true
    }
  },
  components: {
    'header-mobile': HeaderMobile,
    'poi-list': PoiList,
    'poi-map': PoiMap,
    GeoLocationNotification
  },
  data () {
    return {
      directionsDisplay: null,
      hasError: false,
      isMapOpen: false
    }
  },
  created () {
    this.startLoad()
    Promise.all([this.getTours(), this.updatePOIs()]).finally(() => this.endLoad())
  },
  computed: {
    google: gmapApi,
    ...mapGetters({
      position: 'getUserPosition'
    }),
    ...mapState('curated', ['poiList']),
    ...mapGetters('curated', ['getTour']),
    currentTour: function () {
      return this.getTour(parseInt(this.id))
    },
    mapAllowed: function () {
      return this.poiList.length > 0 && this.position !== undefined
    }
  },
  methods: {
    ...mapMutations(['startLoad', 'endLoad']),
    ...mapMutations('poi', ['setCurrentPoiList', 'setCurrentTour', 'setUnfinishedTour']),
    ...mapActions('curated', ['getPOIs', 'getTours']),
    updatePOIs () {
      return new Promise((resolve, reject) => {
        this.getPOIs({ 'tour_id': this.id }).then(() => {
          this.setCurrentPoiList(this.poiList)
          resolve(this.poiList)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    startTour: function () {
      this.startLoad()
      this.getDirections().then((route) => {
        let currentTour = { type: 'Curated', tour: this.currentTour }
        this.endLoad()
        this.setCurrentPoiList(route)
        this.setCurrentTour(currentTour)
        this.setUnfinishedTour({ type: currentTour.type, tour: currentTour.tour, poiList: route })
        this.$router.push({ name: 'PoiDirections', params: { id: route[0].id } })
      }).catch(() => {
        this.endLoad()
        this.hasError = true
      })
    },
    getDirections: function () {
      // Directly accessing map component to allow Promise callback
      return this.$refs.map.getDirections()
    },
    onDirectionsError: function () {
      this.hasError = true
    }
  }
}
</script>
